<template>
  <section class="section">
    <div class="content">
      <p class="title">Report Summary</p>
    </div>
    <div class="columns is-centered">
      <div class="tile is-ancestor notification box is-7">
        <article class="tile is-child">
          <div class="content">
            <p>Reportee: {{ reportSummary.fullName }}</p>
            <p>Report Period: {{ reportSummary.dateRange }}</p>
            <p>Report Generated By: {{ reportSummary.reportGeneratedBy }}</p>
            <p>Approved By:</p>
          </div>
        </article>
        <article class="tile is-child">
          <div class="content">
            <p>
              Total Drive Time: {{ reportSummary.totalDriveTime }}
              {{ driveTimeUnitOfMeasure }}
            </p>
            <p>Mileage Rate: ${{ mileageRate }}</p>
            <p>Total Commuting Miles: {{ reportSummary.totalMileage }}</p>
            <p>
              Total Mileage Reimbursement: ${{
                reportSummary.totalReimbursement
              }}
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    reportSummary: {
      type: Object,
      default: () => {},
      required: true
    },
    driveTimeUnitOfMeasure: {
      type: String,
      default: "minutes",
      required: false
    }
  },
  data() {
    return {
      mileageRate: process.env.VUE_APP_IRS_MILEAGE_RATE
    };
  }
};
</script>
